import type { TourSection } from './types';

export const aiModelsSections: TourSection[] = [
  {
    id: 'catalogo',
    label: 'Para qué sirve esta lista',
    steps: [
      {
        target: '[data-tour="ai-models-header"]',
        title: 'Catálogo de modelos de IA',
        content:
          'Esta es la lista de modelos disponibles para generar contenido con inteligencia artificial. Lo que agregues aquí es exactamente lo que aparece para elegir al crear una configuración de IA: si un modelo no está en esta lista, no se puede usar.',
      },
    ],
  },
  {
    id: 'precios',
    label: 'Precios',
    steps: [
      {
        target: '[data-tour="ai-models-table"]',
        title: 'Cuánto cuesta cada modelo',
        content:
          'Los precios son en dólares por cada millón de palabras procesadas: uno para el texto que se envía y otro para el que devuelve. Con estos valores el sistema calcula el costo de cada sugerencia generada. El precio de salida incluye el razonamiento interno del modelo, que también se cobra.',
      },
    ],
  },
  {
    id: 'nuevo',
    label: 'Agregar un modelo',
    steps: [
      {
        target: '[data-tour="ai-models-new"]',
        title: 'Agregar o actualizar',
        content:
          'El identificador tiene que coincidir exactamente con el nombre del modelo del proveedor. Si tiene un error de escritura no vas a ver un aviso: el modelo queda sin precio y sus sugerencias se guardan sin costo. Si escribes un identificador que ya existe, se actualizan sus datos en lugar de crear otro.',
      },
    ],
  },
  {
    id: 'eliminar',
    label: 'Eliminar un modelo',
    steps: [
      {
        target: '[data-tour="ai-models-table"]',
        title: 'Qué pasa al eliminar',
        content:
          'No se puede eliminar un modelo mientras alguna configuración de IA lo esté usando: el sistema muestra cuáles son para que las cambies primero. Cuenta también las configuraciones desactivadas, porque alcanza un clic para volver a activarlas.',
      },
    ],
  },
];
